import React, { memo } from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import RadioButton from 'design-system/RadioButton';
import { CARD_VIEW_BORDER_RADIUS } from 'design-system/CardView';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const CheckBox = ({ description, value, onValueChange }) => {
    const styles = useStyles(styleSet);
    return (<TouchableBounce style={description !== undefined && styles.container} onPress={() => {
            onValueChange(!value);
        }} testID="checkbox">
      <RadioButton type="multiple" isChecked={value}/>
      {Boolean(description) && (<View style={styles.descContainer}>
          <Text TextThin-14 flex>
            {description}
          </Text>
        </View>)}
    </TouchableBounce>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        backgroundColor: colors.cards.onDark,
        borderRadius: CARD_VIEW_BORDER_RADIUS,
        overflow: 'hidden',
        flexDirection: 'row',
        alignItems: 'center',
        padding: rem(16),
    },
    descContainer: {
        flex: 1,
        paddingHorizontal: rem(16),
    },
}));
/**
 * @param value boolean
 * @param onValueChange `(newValue: boolean) => void`
 * @param description When provided, renders checkbox within a bouncable card
 */
export default memo(CheckBox);
